import React from "react";
import { appExplorerStyles } from "./style.js";
import { CloseOutlined } from "@ant-design/icons";
import AppIcon from "../AppIcon";
import PopUpMenu from "../PopUpMenu";

class AppExplorerGUI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      applications: {},
      popUpOn: false,
      popUpPosition: {},
      popUpEntries: [],
    };
    this.closePopUp = this.closePopUp.bind(this);
    this.setPopUp = this.setPopUp.bind(this);
    this.handleUninstallApp = this.handleUninstallApp.bind(this);
  }

  componentDidMount() {
    this.setState((state) => ({
      ...state,
      applications: this.props.fileSystem.retrieveApps(),
    }));
  }

  handleUninstallApp(hash) {
    const applications = this.state.applications;
    delete applications[hash];
    this.setState((state) => ({
      ...state,
      applications,
    }));
    this.props.fileSystem.uninstallApp(hash);
  }

  closePopUp(e) {
    e.preventDefault();
    if (e.type === "click")
      window.removeEventListener("click", this.closePopUp);
    else window.removeEventListener("contextmenu", this.closePopUp);
    this.setState((state) => ({
      ...state,
      popUpOn: false,
    }));
  }

  setPopUp(x, y, entries) {
    this.setState((state) => ({
      ...state,
      popUpOn: true,
      popUpPosition: { x, y },
      popUpEntries: entries,
    }));
  }

  render() {
    const apps = this.state.applications;
    const appArr = [];
    const scale = this.props.systemData.iconSize;

    for (let key in apps) {
      const app = apps[key];
      const metadata = app.getMetaData();
      appArr.push(
        <AppIcon
          key={metadata.hash}
          icon={
            metadata.icon ? (
              <img
                alt={""}
                style={appExplorerStyles.icon}
                src={metadata.icon}
              />
            ) : (
              <div style={appExplorerStyles.icon}></div>
            )
          }
          name={metadata.name}
          nameChangable={false}
          width={100}
          height={110}
          onClick={(e) => {
            this.props.addCurrentApp(app);
          }}
          onRightClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            window.addEventListener("click", this.closePopUp);
            this.setPopUp(e.clientX, e.clientY, [
              {
                content: "Inspect Raw",
                func: () => this.props.addCurrentRaw(metadata.hash),
              },
              {
                content: "Uninstall",
                func: () => this.handleUninstallApp(metadata.hash),
              },
            ]);
          }}
          nameOnChange={false}
          scale={scale}
        />
      );
    }

    return (
      <>
        <div
          style={{
            width: "100%",
            height: this.props.explorerOn ? "100%" : "0%",
            opacity: this.props.explorerOn ? 1 : 0,
            ...appExplorerStyles.frame,
          }}
        >
          <div style={appExplorerStyles.container}>
            <div style={appExplorerStyles.title}>Applications</div>
            <div
              style={{
                ...appExplorerStyles.appContainer,
                width:
                  Math.floor((this.props.dims.width * 0.8) / (100 * scale)) *
                    (100 * scale) +
                  "px",
              }}
            >
              {appArr}
            </div>
          </div>
          <div
            style={appExplorerStyles.exitBtn}
            onClick={this.props.toggleAppExplorer}
          >
            <CloseOutlined style={{ color: "white", fontSize: 24 }} />
          </div>
          {this.state.popUpOn && (
            <PopUpMenu
              top={this.state.popUpPosition.y}
              left={this.state.popUpPosition.x}
              entries={this.state.popUpEntries}
            />
          )}
        </div>
      </>
    );
  }
}

export default AppExplorerGUI;
